'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.provider('DocumentStore', function(StoreTemplate) {
  let sizeOfUploadedDocuments = 0;
  let documents;
  let uploadedDocuments;
  let requiredDocuments;
  let taxDocuments;
  let taxDocumentsDocManager;

  // Transitive UI state
  let loadingStates = {
    general: false,
    required: false,
    uploaded: false,
    tax: false
  };

  let uploadingStatus = false;
  let uploadSuccess = false;
  let uploadFile = {};
  let uploadError = {};

  let downloadPending = false;

  let uploadProgress = 0;

  return StoreTemplate.extend({
    getterFns: {
      getDocuments() {
        return documents;
      },
      getRequiredDocuments() {
        return requiredDocuments;
      },
      getUploadedDocuments() {
        return uploadedDocuments;
      },
      getTaxDocuments() {
        return taxDocuments;
      },
      getTaxDocumentsDocManager() {
        return taxDocumentsDocManager;
      },
      getSizeOfUploadedDocuments() {
        return sizeOfUploadedDocuments;
      },
      getUploadingStatus() {
        return uploadingStatus;
      },
      getUploadSuccess() {
        return uploadSuccess;
      },
      getUploadError() {
        return uploadError;
      },
      getUploadFile() {
        return uploadFile;
      },
      getLoadingStates() {
        return loadingStates;
      },
      getDownloadPending() {
        return downloadPending;
      },
      getUploadProgress() {
        return uploadProgress;
      }
    },
    dispatcherListeners: {
      'document:setDocuments'(documentObj) {
        if (angular.isArray(documentObj.documents)) {
          documents = documentObj.documents;
        }
      },
      'document:setRequiredDocuments'(requiredDocs) {
        if (angular.isArray(requiredDocs['outstanding-documents'])) {
          requiredDocuments = requiredDocs['outstanding-documents'];
        }
      },
      'document:setTaxDocuments'(taxDocs) {
        if (angular.isArray(taxDocs.taxDocumentList)) {
          taxDocuments = taxDocs.taxDocumentList;
        }
        if (angular.isArray(taxDocs.taxDocumentDocStoreList)) {
          taxDocumentsDocManager = taxDocs.taxDocumentDocStoreList;
        }
      },
      'document:setUploadedDocuments'(uploadedDocs) {
        if (angular.isArray(uploadedDocs.documents)) {
          uploadedDocuments = uploadedDocs.documents;
        }
      },
      'document:addUploadedDocument'(document) {
        if (angular.isObject(document)) {
          uploadedDocuments = _.compact([document].concat(uploadedDocuments));
          sizeOfUploadedDocuments = sizeOfUploadedDocuments + 1;
        }
      },
      'document:setSizeOfUploadedDocuments'(size) {
        if (angular.isNumber(size)) {
          sizeOfUploadedDocuments = size;
        }
      },
      'document:setUploadProgress'(progress) {
        if (angular.isNumber(progress)) {
          uploadProgress = progress;
        }
      },
      'document:markDocumentAsRead'(documentId) {
        if (angular.isString(documentId)) {
          documents = documents.map((document) => {
            if (document.id === documentId) {
              return {
                id: document.id,
                date: document.date,
                description: document.description,
                size: document.size,
                type: document.type,
                read: true
              };
            } else {
              return document;
            }
          });
        }
      },
      'document:markTaxDocumentAsRead'(documentId) {
        if (angular.isString(documentId)) {
          taxDocumentsDocManager = taxDocumentsDocManager.map((taxDocument) => {
            if (taxDocument.id === documentId) {
              return {
                id: taxDocument.id,
                date: taxDocument.date,
                description: taxDocument.description,
                size: taxDocument.size,
                type: taxDocument.type,
                read: true
              };
            } else {
              return taxDocument;
            }
          });
        }
      },
      'document:setUploadingStatus'(status) {
        if (status === true || status === false) {
          uploadingStatus = status;
        }
      },
      'document:setUploadSuccess'(success) {
        if (success === true || success === false) {
          uploadSuccess = success;
        }
      },
      'document:setUploadFile'(file) {
        if (angular.isObject(file)) {
          uploadFile = file;
        }
      },
      'document:setUploadError'(error) {
        if (angular.isObject(error)) {
          uploadError = error;
        }
      },
      'document:setDownloadPending'(downloading) {
        if (downloading === true || downloading === false) {
          downloadPending = downloading;
        }
      },
      'document:setLoadingState'(newStates) {
        if (angular.isObject(newStates)) {
          loadingStates = _.assign({}, loadingStates, newStates);
        }
      },
      'document:clearUploadStatus'() {
        uploadingStatus = false;
        uploadSuccess = false;
        uploadFile = {};
        uploadError = {};
      }
    }
  });
});
